import { useContext } from "react";
import { createPortal } from "react-dom";
import { StateContext } from "../../../context/globalContext/context";
import { iGlobalContext } from "../../../context/globalContext/interface";
import DialogPopup from "../dialogPopup/dialogPopup";
import AppLoader from "../appLoader/appLoader";
import styles from "./NewLoader.module.scss";
import AppButton from "../button/button";

interface iProps {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  loaderIcon1?: any;
  text: string;
  subText?: string;
  loaderIcon2?: any;
  failureIcon?: any;
  cancelButtonClassName?: string;
  hideLoader?: boolean;
  loadFullScreen?: boolean;
  bottomBtnText?: string;
  hideCancelBtn?: boolean;
}
function NewLoader(props: iProps): JSX.Element {
  const {
    className = "",
    isOpen,
    onClose,
    loaderIcon1,
    loaderIcon2,
    text = "",
    cancelButtonClassName = "",
    hideLoader = false,
    loadFullScreen = false,
    failureIcon,
    subText = "",
    bottomBtnText = "Cancel",
    hideCancelBtn = false,
  } = props;

  const globalContext = useContext(StateContext);
  const { isMobile }: iGlobalContext = globalContext;
  const showBottomButton = bottomBtnText && !hideCancelBtn;
  if (isMobile || loadFullScreen)
    return createPortal(
      <DialogPopup className={`${styles.newLoaderContainer}`} isOpen={isOpen}>
        <div className={`${className} ${styles.newLoaderComponent}`}>
          <div className={styles.imageContainer}>
            {loaderIcon1 && <img className={styles.loaderIcon} src={loaderIcon1} alt="loading icon" />}
            {loaderIcon2 && <img className={styles.loaderIcon} src={loaderIcon2} alt="loading icon" />}
            {failureIcon && <img className={styles.failureIconStyles} src={failureIcon} alt="failure icon" />}
          </div>

          {text && <p className={`${styles.loaderText} ${subText && styles.subTextExists}`}>{text}</p>}
          {subText && <p className={`${styles.loaderSubText}`}>{subText}</p>}
          {!hideLoader && <AppLoader />}
          {showBottomButton && (
            <AppButton variant="secondary" className={`${styles.cancelBtn} ${cancelButtonClassName}`} onClick={onClose}>
              {bottomBtnText}
            </AppButton>
          )}
        </div>
      </DialogPopup>,
      document.body
    );

  return (
    <div
      className={`${styles.newLoaderContainer}`}
      // isOpen={isOpen}
      style={{ display: isOpen ? "flex" : "none" }}
    >
      <div className={`${className} ${styles.newLoaderComponent}`}>
        <div className={styles.imageContainer}>
          {loaderIcon1 && <img className={styles.loaderIcon} src={loaderIcon1} alt="loading icon" />}
          {loaderIcon2 && <img className={styles.loaderIcon} src={loaderIcon2} alt="loading icon" />}
          {failureIcon && <img className={styles.failureIconStyles} src={failureIcon} alt="failure icon" />}
        </div>

        {text && <p className={`${styles.loaderText} ${subText && styles.subTextExists}`}>{text}</p>}
        {subText && <p className={styles.loaderSubText}>{subText}</p>}
        {!hideLoader && <AppLoader />}
        <AppButton variant="secondary" className={`${cancelButtonClassName} ${styles.cancelBtn} `} onClick={onClose}>
          Cancel
        </AppButton>
      </div>
    </div>
  );
}

export default NewLoader;
